import React, { useEffect, useState } from 'react'
import { SearchBoxProvided } from 'react-instantsearch-core'
import { connectSearchBox } from 'react-instantsearch-dom'
import { VirtualSearchBoxType } from './types'

const SearchInput: React.FC<SearchBoxProvided & VirtualSearchBoxType> = ({ location, refine, className }) => {
  let params = new URLSearchParams(location.search)
  const [searchTerm, setSearchTerm] = useState(params.get('q') || '')

  useEffect(() => {
    params = new URLSearchParams(location.search)
    const defaultRefinement = params.get('q')
    if (defaultRefinement) {
      setSearchTerm(defaultRefinement)
      refine(defaultRefinement)
    } else {
      setSearchTerm('')
      refine('')
    }
  }, [location.search])

  return <input onChange={() => setSearchTerm(searchTerm)} className={className} />
}

export const VirtualSearchBox = connectSearchBox(SearchInput)
